<template>
  <div class="produit-usage_main_posologie table border border-gris-bordure">
    <div class="row table_head">
      <div class="cell" v-for="(column, index) in columns" :key="index">
        {{ column.text }}
      </div>
    </div>

    <div class="row" v-for="(row, rowIndex) in table" :key="rowIndex">
      <div
        class="cell"
        v-for="(column, colIndex) in columns"
        :key="colIndex"
        :col-title="column.text"
      >
        <slot
          :name="`row.${column.value}`"
          :row="row"
          :value="row[column.value]"
        >
          <div>
            {{ row[column.value] }}
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RowTable',
  props: {
    table: Array, // Tableau d'objets
    columns: Array // Tableau d'objets
  }
}
</script>
